import React from 'react';
import clsx from 'clsx';
import { AdvantageItemProps } from './advantage-type-defs';
import { useLocale } from '@/components/providers/context/locale-context';

function AdvantageItem({
    props,
    icon,
}: Readonly<{
    props: AdvantageItemProps;
    icon: React.ReactElement;
}>) {
    return (
        <div className="flex h-full w-full flex-col rounded-[8px] bg-[#FFFFFF0F] p-[16px] sm:p-[32px]">
            <div className="h-[48px] w-[48px]">{icon}</div>
            <h3
                style={{ height: '3em', lineHeight: '1.5em' }}
                className={clsx(
                    'j-h5 mt-[16px] text-left text-[#FFFFFF] sm:mt-[40px]',
                )}
            >
                {props.title}
            </h3>
            <div
                className={clsx('j-t2 mt-[8px] text-[#FFFFFF99] sm:mt-[16px]')}
            >
                {props.description}
            </div>
        </div>
    );
}

export default AdvantageItem;
